import m from 'mithril';
import button from "../button/index";
import { Icons, Portal } from "../../../old/tools/constructui";
import pf from "../../../old/pf";

export default () => {

    let locallinks = [];
    let updating = false;
    let updateDone = false;
    return {
        oninit: ({ attrs: { links } }) => {
            if (links)
                locallinks = links;
        },
        view: ({ attrs: { reportlink, editable, localText, links, localValue, nf, nfd, tact, LocalUpdateField } }) => {
            // console.log({ locallinks })

            if (!editable || updateDone) {
                return locallinks.map(l => {
                    return m(button, {
                        label: l.caption || "Report Link", iconLeft: Icons.LINK, href: l.url, target: "_blank"
                    })
                })
            }
            else
                if (editable && reportlink) {
                    return m(button, {
                        label: "Generate Link",
                        loading: updating,
                        onclick: () => {
                            updating = true;
                            m.redraw();
                            pf
                                .APIAction("UpdateValueForNF", {
                                    tact,
                                    nf,
                                    // value: url,
                                    reportlink,
                                    needlinks: true,
                                })
                                .then((r) => {
                                    result = r;

                                    if (r.success) {
                                        console.log({ r });
                                        locallinks = [];
                                        var newURL = r.url;
                                        locallinks.push({ url: newURL });
                                        updateDone = true;
                                        LocalUpdateField(true, nf, undefined, undefined, locallinks)
                                        updating = false;
                                        m.redraw();
                                    }
                                })
                        }
                    })
                }
        },
    };
};